export const PRESIST_AUTH = '@@LOGIN/PRESIST_AUTH';
export const REHYDRATE_AUTH = '@@LOGIN/REHYDRATE_AUTH';
export const SPINNER_OFF = '@@LOGIN/SPINNER_OFF';
export const SPINNER_ON = '@@LOGIN/SPINNER_ON';
export const LOGIN = '@@SECURITY_FUND/LOGIN';
export const LOGOUT = '@@SECURITY_FUND/LOGOUT';
export const LOGIN_SUCCESS = '@@SECURITY_FUND/LOGIN_SUCCESS';
export const LOGIN_FAILURE = '@@SECURITY_FUND/LOGIN_FAILURE';


export const SIGN_IN_WITH_GOOGLE = '@@LOGIN/SIGN_IN_WITH_GOOGLE';
export const SIGN_IN_WITH_FACEBOOK = '@@LOGIN/SIGN_IN_WITH_FACEBOOK';
export const SING_IN_WITH_APPLE = '@@LOGIN/SIGN_IN_WITH_APPLE';


export const actionCreators = {
    login: (payload) => ({
        type: LOGIN, 
        payload
    }),
    logOut: (payload) => ({
        type: LOGOUT, 
        payload
    }),
    logout: (payload) => ({
        type: LOGOUT, 
        payload
    }), 
    loginSuccess: (payload) => ({
        type: LOGIN_SUCCESS,
        payload
    }),
    loginFailure: (payload) => ({
        type: LOGIN_FAILURE,
        payload
    }),
    presistAuth: (payload) => ({
        type: PRESIST_AUTH, 
        payload
    }), 
    rehydrateAuth: (payload) => {
        return({
        type: REHYDRATE_AUTH,
        payload
    })},
    spinnerOff: () => ({
        type: SPINNER_OFF,
        payload: false
    }),
    spinnerOn: () => ({
        type: SPINNER_ON,
        payload: true
    }),
    signInWithGoogle: (payload) => ({
        type: SIGN_IN_WITH_GOOGLE,
        payload
    }),
    signInWithFacebook: (payload) => ({
        type: SIGN_IN_WITH_FACEBOOK,
        payload
    }),
    signInWithApple: (payload) => ({
        type: SING_IN_WITH_APPLE,
        payload
    }),
};
